import React, { useEffect } from "react";
import "./App.scss";
import { useLocation, useNavigate, useRoutes } from "react-router-dom";
import routes, { defaultPath, privatePath } from "./routes";

function App() {
  const element = useRoutes(routes);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(
    function () {
      if (location.pathname === defaultPath) {
        navigate(privatePath);
      }
    },
    [location, navigate],
  );

  return <div className="App">{element}</div>;
}

export default App;
